/**
 * Handing a fetched proof to the browser.
 *
 * The bytes only ever reach the page through a credentialed fetch, so the
 * object URL created here is the single place a proof URL exists — and it is
 * revoked as soon as the browser has taken the download. Nothing stores it.
 */
const EXTENSION_BY_CONTENT_TYPE: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/heic": "heic",
  "application/pdf": "pdf",
};

/** Names the file after the payment, so a folder of proofs stays sortable. */
export const proofFileName = (
  paymentId: string,
  contentType: string | null,
): string => {
  const mime = contentType?.split(";")[0] ?? "";
  const extension = EXTENSION_BY_CONTENT_TYPE[mime] ?? "bin";
  return `proof-${paymentId.slice(0, 8)}.${extension}`;
};

export const saveBlobAs = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Next tick rather than immediately: the download is kicked off synchronously
  // but revoking in the same frame races it in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
